<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-desktop', fontSet: 'fad'}"
	[headerText]="T.PLAYER_SELECTION_SELECT_PLAYER_TEXT | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<mat-list>
			@for (player of data?.trainingRoom?.debriefingPlayers; track player; let last = $last) {
				<mat-list-item>
					<button
						(click)="selectPlayer(player)"
						[class.active]="playerAlreadySelected(player)"
						[disabled]="player?.webSocket?.activityState !== ActivityState.Active"
						class="selectedPlayerBtn w-100"
						color="accent"
						mat-raised-button
					>
						{{ player.customName }}
					</button>
					@if (!last) {
						<mat-divider [inset]="true" />
					}
				</mat-list-item>
			}
		</mat-list>
	</ng-container>

	<ng-container actions>
		@if (!data.multiSelect) {
			<sim-button
				(onClick)="close({action: 'cancel', selectedPlayer: null})"
				[color]="'primary'"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.BUTTON_CANCEL"
			/>
		}
		@if (data.multiSelect) {
			<sim-button
				(onClick)="close({action: 'ok', selectedPlayers: data.selectedPlayers})"
				[color]="'primary'"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.BUTTON_OK"
			/>
		}
	</ng-container>
</sim-basic-material-dialog>
